import { listaSimNao } from './../shared/listas-parametros';
import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { ProdutoSegmento } from './produto-segmento.model';
import { NTECH_API } from '../app.api';
import { FuncaoEquipamentoService } from '../funcao-equipamento/funcao-equipamento.service';
import { FuncaoEquipamento } from './../funcao-equipamento/funcao-equipamento.model';
import { Produto } from '../produto/produto.model';
import { ProdutoService } from './../produto/produto.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-produto-segmento',
  templateUrl: './produto-segmento.component.html',
  styleUrls: ['./produto-segmento.component.css']
})
export class ProdutoSegmentoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  listaProdutoSegmento: CustomStore;
  listaFuncaoEquipamentos: FuncaoEquipamento[] = [];
  listaProduto: Produto[] = [];
  alturaGrid = null;

  listasForm = [
    {Nome: 'listaFuncaoEquipamentos', status: false},
    {Nome: 'listaProduto', status: false}
  ];

  listaSimNao = listaSimNao;

  colunasGridProdutoSegmento = [];

  editOptionsGridProdutoSegmento = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'ProdutoSegmento',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private funcaoEquipamentoService: FuncaoEquipamentoService,
    private produtoService: ProdutoService
  ) {

    // carrega a lista de FuncaoEquipamento
    this.funcaoEquipamentoService.getFuncaoEquipamentos()
      .subscribe(funcaoEquipamentos => {
        this.listaFuncaoEquipamentos = funcaoEquipamentos;
        this.verificarListasCarregadas('listaFuncaoEquipamentos');
      },
      error => {
        this.verificarListasCarregadas('listaFuncaoEquipamentos');
      }
    );

    // carrega a lista de Produto
    this.produtoService.getProdutos()
      .subscribe(produtos => {
        this.listaProduto = produtos;
        this.verificarListasCarregadas('listaProduto');
      },
      error => {
        this.verificarListasCarregadas('listaProduto');
      }
    );

    this.listaProdutoSegmento = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/produto-segmento/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/produto-segmento/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/produto-segmento/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/produto-segmento/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    // altera o status da lista informada para true
    if (nomeLista !== '') {
      const foundItem = this.listasForm.find((fItem) => fItem.Nome === nomeLista);

      if (foundItem) {
        foundItem.status = true;
      }
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if ( (this.listasForm[0].status === true) &&
         (this.listasForm[1].status === true) ) {

      this.colunasGridProdutoSegmento = [
        {
          dataField: 'Id',
          dataType: 'string',
          caption: 'ID',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'DescricaoProdutoSegmento',
          dataType: 'string',
          caption: 'Descrição',
          validationRules: [{
            type: 'required',
            message: 'Descrição é obrigatório.'
          }]
        },
        {
          dataField: 'IdProduto',
          caption: 'Produto',
          lookup: {
              dataSource: this.listaProduto,
              displayExpr: 'DescricaoProduto',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Produto é obrigatório.'
          }]
        },
        {
          dataField: 'IdFuncaoEquipamento',
          caption: 'Função do Equipamento',
          lookup: {
              dataSource: this.listaFuncaoEquipamentos,
              displayExpr: 'DescricaoFuncaoEquipamento',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Função do Equipamento é obrigatório.'
          }]
        },
        {
          dataField: 'CobrancaUnica',
          caption: 'Cobrança Única',
          lookup: {
              dataSource: this.listaSimNao,
              displayExpr: 'Descricao',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Cobrança única é obrigatória.'
          }]
        }
      ];

      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/produto-segmento/produto-segmento.component.ts